


















import Vue from 'vue';
import { get } from 'lodash';
import { format } from 'date-fns';
import DateRange from './DateRange.vue';
import Repeat from './Repeat.vue';
import ScheduleMessage from './ScheduleMessage.vue';
import { DATE_FORMAT, RecurrenceTypes, PeriodOptions } from './utils';
import { createStringRule } from './rules';

const apollo = () => import('../../vue-apollo');

const component = {
  name: 'Schedule',
  components: {
    DateRange,
    Repeat,
    ScheduleMessage,
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          startDate: format(new Date(), DATE_FORMAT),
          endDate: null,
          repeatOption: null,
          stopRepeating: null,
          stopOn: null,
          repeatOn: null,
          repeatTimes: 1,
          repeatInterval: 1,
          period: null,
        };
      },
    },
    objectType: {
      type: String,
      required: true,
    },
  },
  computed: {
    recurrenceType() {
      const repeatOption = get(this.form, 'repeatOption.value', PeriodOptions.DoesNotRepeat);
      return repeatOption === PeriodOptions.Custom ? RecurrenceTypes.Custom : RecurrenceTypes.Standard;
    },
    rule() {
      return createStringRule(this.form);
    },
  },
};

// this resolves a issue related to https://github.com/mengxiong10/vue2-datepicker/blob/master/src/date-picker.vue and vue-apollo
// see https://github.com/vuejs/vue-apollo/issues/532
if (!Vue.prototype.hasOwnProperty('$apollo')) {
  apollo().then(({ createProvider }) => {
    component.apolloProvider = createProvider();
  });
}
export default Vue.extend(component);
